import React from 'react'
import { observer } from 'mobx-react'
import { computed, makeObservable } from 'mobx'
import Skeleton from 'react-loading-skeleton'

import {
   reactTableLoaderTypes,
   REACT_LOADING_DURATION
} from '../../Loader/constants'

import {
   AdhocTasksLoader,
   ListViewLoadingWrapper,
   ListViewTableWrapper
} from './styledComponents'

interface ListViewLoaderProps {
   numberOfReactTables?: number
   reactTableLoaderType?: string
   numberOfTaskInTable?: number
}

class ListViewLoader extends React.Component<ListViewLoaderProps> {
   static defaultProps = {
      numberOfReactTables: 1,
      numberOfTaskInTable: 5
   }

   constructor(props: ListViewLoaderProps) {
      super(props)

      makeObservable(this, {
         numberOfSkeletonFields: computed
      })
   }

   get numberOfSkeletonFields(): number {
      const { reactTableLoaderType } = this.props
      const {
         advancedBoardSubtask,
         advancedBoardListView,
         advancedBoardSingleListView,
         taskDetailedViewSubtask,
         taskDetailedViewRelatedTask,
         advancedBoardListViewPagination,
         bucketTableView
      } = reactTableLoaderTypes

      switch (reactTableLoaderType) {
         case bucketTableView:
         case advancedBoardListView:
            return 4
         case advancedBoardSubtask:
            return 4
         case advancedBoardSingleListView:
            return 4
         case advancedBoardListViewPagination:
            return 4
         case taskDetailedViewSubtask:
            return 3
         case taskDetailedViewRelatedTask:
            return 3
         default:
            return 0
      }
   }
   renderAdhocListLoader = () => (
      <>
         {Array.from(Array(this.props.numberOfTaskInTable).keys()).map(
            index => (
               <AdhocTasksLoader key={index} className='table-task-loader'>
                  <Skeleton
                     duration={REACT_LOADING_DURATION}
                     width={80}
                     height={20}
                     style={{
                        marginRight: 8,
                        marginLeft: 8
                     }}
                  />
                  <Skeleton
                     duration={REACT_LOADING_DURATION}
                     width={120}
                     height={12}
                     style={{
                        marginRight: 8,
                        marginLeft: 8,
                        flexGrow: 2,
                        width: '100%'
                     }}
                  />
                  <Skeleton
                     wrapper={props => (
                        <div style={{ flexGrow: 0 }} {...props}></div>
                     )}
                     duration={REACT_LOADING_DURATION}
                     count={1}
                     circle={true}
                     height={32}
                     width={32}
                     style={{
                        marginRight: 15,
                        marginLeft: 15
                     }}
                  />
                  <Skeleton
                     duration={REACT_LOADING_DURATION}
                     count={1}
                     circle={true}
                     height={32}
                     width={32}
                     style={{
                        marginRight: 15,
                        marginLeft: 15
                     }}
                  />
                  {Array.from(Array(this.numberOfSkeletonFields).keys()).map(
                     index => (
                        <Skeleton
                           key={index}
                           duration={REACT_LOADING_DURATION}
                           width={100}
                           height={20}
                           count={1}
                           style={{
                              marginRight: 8,
                              marginLeft: 8,
                              flexGrow: 1
                           }}
                        />
                     )
                  )}
               </AdhocTasksLoader>
            )
         )}
      </>
   )

   render() {
      const { numberOfReactTables, reactTableLoaderType } = this.props
      return (
         <ListViewLoadingWrapper>
            {Array.from(Array(numberOfReactTables).keys()).map(index => (
               <ListViewTableWrapper
                  key={index}
                  reactTableLoaderType={reactTableLoaderType}
                  numberOfTaskInTable={this.props.numberOfTaskInTable}
                  className={'list-view-table-loading-wrapper'}
               >
                  {this.renderAdhocListLoader()}
               </ListViewTableWrapper>
            ))}
         </ListViewLoadingWrapper>
      )
   }
}

export default observer(ListViewLoader)
